<template>
  <div class="animated fadeIn pt2 pb4">
    <template>
      <div class="clearfix gibson px2 mb2" v-if="haaid">
        <div class="col-12 px0" v-if="showMobile">
          <div v-if="basic" class="absolute left-0 right-0 top-0 bottom-0 transparent-darkblue-background white p4 col-12 flex flex-column justofy-center items-start z2">
            <div>
              <p class="h4 gibson regular white line-height-golden">Som basismedlem har du desværre ikke adgang til denne del af partner-login.<br>
                Opgrader din løsning, hvis du vil have adgang.
              </p>
              <button :disabled="isLoadingMail" @click="handleSubmitMail" class="p2 my2 white-button flex justify-center items-center gibson h5 not-rounded border-none line-height-1">
                <span>Kontakt mig</span>
                <span class="mx2"><i class="el-icon-right"></i></span>
              </button>
            </div>
          </div>
          <div class="clearfix p2 py3">
            <div class="col-12 px0">
              <p class="h4 semi-bold line-height-2 my2">Din hjemmeside</p>
              <p class="h5 regular darkblue line-height-golden mb3">
                Hvis du er kunde hos Håndværker.dk, har du mulighed for at få en gratis hjemmeside, som bygger på indholdet fra din Håndværker.dk profil.
              </p>
            </div>
            <haandvaerker></haandvaerker>
            <template>
              <div v-if="haaid !== '0'" >
                <a v-if="url !== ''" target="_blank" :href="`http://www.kundematch.dk/website/public/${url}/${haaid}/index.html`" type="submit" size="lg" class="col-12 outlined-action-button h4 semi-bold gibson p2 flex justify-center items-center not-rounded no-hover text-decoration-none">
                  <span>Se din hjemmeside</span>
                  <span class="mx2">
                    <i class="el-icon-right"></i>
                  </span>
                </a>
                <a v-if="url !== ''" target="_blank" :href="`https://mail.jobcatcher.dk/rainloop`" type="submit" size="lg" class="col-12 outlined-action-button h4 semi-bold gibson p2 flex justify-center items-center not-rounded no-hover text-decoration-none">
                  <span>Webmail</span>
                  <span class="mx2">
                    <i class="el-icon-right"></i>
                  </span>
                </a>
                <a v-if="url !== ''" target="_blank" :href="`https://mail.jobcatcher.dk/`" type="submit" size="lg" class="col-12 outlined-action-button h4 semi-bold gibson p2 flex justify-center items-center not-rounded no-hover text-decoration-none">
                  <span>E-mailindstillinger</span>
                  <span class="mx2">
                    <i class="el-icon-right"></i>
                  </span>
                </a>
              </div>
            </template>
          </div>
          <div class="clearfix px2">
            <websitecontrols @UpdateUrl="UpdateUrl"></websitecontrols>
          </div>
        </div>
        <div class="col-10 px0 ml4" v-if="!showMobile">
          <div v-if="basic" class="absolute left-0 right-0 top-0 bottom-0 transparent-darkblue-background white p4 col-12 flex flex-column justofy-center items-start z2">
            <div>
              <p class="h4 gibson regular white line-height-golden">Som basismedlem har du desværre ikke adgang til denne del af partner-login.<br>
                Opgrader din løsning, hvis du vil have adgang.
              </p>
              <button :disabled="isLoadingMail" @click="handleSubmitMail" class="p2 my2 white-button flex justify-center items-center gibson h5 not-rounded border-none line-height-1">
                <span>Kontakt mig</span>
                <span class="mx2"><i class="el-icon-right"></i></span>
              </button>
            </div>
          </div>
          <div class="clearfix p2 py3">
            <div class="col-8 px0">
              <p class="h4 semi-bold line-height-2 my2">Din hjemmeside</p>
              <p class="h5 regular darkblue line-height-golden mb3">
                Hvis du er kunde hos Håndværker.dk, har du mulighed for at få en gratis hjemmeside, som bygger på indholdet fra din Håndværker.dk profil.
              </p>
            </div>
            <haandvaerker></haandvaerker>
            <div class="flex justify-start" v-if="haaid !== '0'" >
              <a v-if="url !== ''" target="_blank" :href="`http://www.kundematch.dk/website/public/${url}/${haaid}/index.html`" type="submit" class="no-hover outlined-action-button h5 semi-bold gibson p2 flex justify-center items-center not-rounded mr2">
                <span>Se din hjemmeside</span>
                <span class="mx2">
                  <i class="el-icon-right"></i>
                </span>
              </a>
              <a v-if="url !== ''" target="_blank" :href="`https://mail.jobcatcher.dk/rainloop`" type="submit" class="no-hover outlined-action-button h5 semi-bold gibson p2 flex justify-center items-center not-rounded mr2">
                <span>Webmail</span>
                <span class="mx2">
                  <i class="el-icon-right"></i>
                </span>
              </a>
              <a v-if="url !== ''" target="_blank" :href="`https://mail.jobcatcher.dk/`" type="submit" class="no-hover outlined-action-button h4 semi-bold gibson p2 flex justify-center items-center not-rounded no-hover text-decoration-none">
                <span class="mr1">E-mailindstillinger</span>
                <span>
                  <i class="el-icon-right"></i>
                </span>
              </a>
            </div>
          </div>
          <div class="clearfix px2">
            <websitecontrols @UpdateUrl="UpdateUrl"></websitecontrols>
          </div>
          <noneligibleFeaturepop ref="noneligibleFeaturepop"></noneligibleFeaturepop>
        </div>
      </div>
      <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
    </template>
  </div>
</template>
<script>
import websitecontrols from './WebsiteControls'
import Haandvaerker from './haandvaerker'
import noneligibleFeaturepop from './noneligibleFeaturepop'
export default {
  name: 'website',
  components: {
    Haandvaerker,
    websitecontrols,
    noneligibleFeaturepop
  },
  data () {
    return {
      haaid: '',
      basic: false,
      isLoadingMail: false,
      url: '',
      eligible: ''
    }
  },
  created () {
    this.eligible = localStorage.getItem('ExternalProWebsite')
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
    this.haaid = localStorage.getItem('haaid')
    if (localStorage.getItem('basic') === '1') {
      this.basic = true
    }
  },
  mounted () {
    this.getdataigibility('/newsfeed')
  },
  methods: {
    getdataigibility (link) {
      if (this.eligible === 'false') {
        this.$refs.noneligibleFeaturepop.showmodel(this.eligible, link, 'ExternalProWebsite')
      }
    },
    UpdateUrl (url) {
      this.url = url
    },
    handleSubmitMail () {
      this.isLoadingMail = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      var data = {operation: 'basicemail_partner_profile', salesPerson: this.salesPerson, textReason: 'Din Hjemmside'}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              let obj = {
                title: 'Vi kontakter dig snarest muligt!',
                message: '',
                type: 'success',
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
              this.isLoadingMail = false
              this.textReason = ''
            } else {
              alert(res.message)
              this.isLoadingMail = false
            }
          },
          response => {
            alert('error')
          }
        )
    }
  }
}
</script>



// WEBPACK FOOTER //
// Website.vue?b373605e